/* eslint-disable import/no-anonymous-default-export */
export default {
  gs3t_first_title: "Qingping Temp & RH Monitor T",
  goose3t: "Qingping Temp & RH Monitor T",
  gs3t_first_desc_2: "Supports Matter",
  gs3t_banner_title: "Qingping Temp & RH Monitor T",
  gs3t_banner_desc: "See Temperature and{br}Humidity at a Glance",
  gs3t_matter_title: "Supports Matter{sup}",
  gs3t_matter_desc: "Works with Apple Home, Google Home, Amazon Alexa,{br}Samsung SmartThings and other Matter-compatible smart home platforms.",
  gs3t_matter_desc1: "Ask Siri to check the temperature and humidity, and stay{br}informed about your indoor environment.",
  gs3t_matter_desc2: "Set up smart routines with Alexa, such as turning on the air{br}conditioner when the temperature rises{sup}.",
  gs3t_ten_list1: "Requires a Matter hub device and a Thread Border Router (or a Matter hub device with integrated Thread support, such as the latest HomePod, Apple TV, Google Nest Hub, Amazon Echo, etc.).",
  gs3t_ten_list2: "Requires Alexa app routines and a compatible smart air conditioner.",
  gs3t_ten_list3: "The actual battery life may vary depending on the environment and battery.",
  gs3t_name: "Qingping Temp & RH Monitor T",
  gs3t_model: "CGG3T",
  gs3t_ble: "Thread, Bluetooth",
  gs3t_param_platform: "Works with Apple Home, Google Home, Amazon Alexa, Samsung SmartThings, and other Matter-compatible smart home platforms.",
  gs3t_support_matter: "Supported Matter",
}
